import type { ApiListStructure, ApiSimpleResponseStructure } from "~/modules/nuxt3-module-doyac/composables/common"
import { $dy__fetchWithToken, extractDataOrFailure, useDYFetch, useDYFetchWithToken } from "~/modules/nuxt3-module-doyac/composables/fetch"
import { useDYAdminConfig } from "./config"
import { useDYAppConfig } from "~/modules/nuxt3-module-doyac/composables/config"

export interface ElectronicAuthorization {
  /**
   * 타입의 한글명
   */
  gubun: string
  isMain: boolean | null
  insertedTime: string
  name: string
  no: number
  requester: string
  title: string
  type: string
  require_auth_type: string[]
  /**
   * 서명한 사람만큼 번호가 들어옴
   */
  approver: string[]
  status?: string
  teamOfRequester?: string
  site?: string | null
}

export interface ElectronicAuthorizationRefundPayment {
  originalPrice: number
  no: number
  /**
   * 2026-11-02 추가 (버그신고 #18): 강의 결제(dy_lecture_book)의 상품 typedPk. 그 외 테이블은 null.
   * 곡별강의('mc' 접두) 판별용 — [결재 수정] 모달의 '악보/MR 취소' 옵션 노출 조건(DYAEaDetail.vue)
   */
  typedPk?: string | null
  cashReceiptState: 'y' | 'n' | 'standby'
  money_day: string
  moneyYn: boolean
  mMethod: number
  // tel: string
  orderNo: string
  orderTid: string
  paymentName: string
  price: number
  book_price: number
  goods_price: number
  akbo_price: number
  mr_price: number
  delivery_cost: number
  totalPrice: number
  used_cash: number
  coupon_discount: number
  jang_payment: {
    count: number
    totalPrice: number
    data: {
      no: number
      price: number
      isRefund: boolean
      refundPrice: number
    }[]
  }
}

export interface ElectronicAuthorizationRefundItem {
  no: number
  id: string
  relatedWithInNo: number
  targetTable: string
  point: number
  cash: number
  isCancel: any | null
  regdate: string
  regdate2: any | null
  relatedInsertNo: number
  title: string
}

export interface ElectronicAuthorizationRefundData {
  reclaimedPoint: Omit<ElectronicAuthorizationRefundItem, 'cash'>[]
  refundedCash: Omit<ElectronicAuthorizationRefundItem, 'point'>[]
}

export interface ElectronicAuthorizationShow extends ElectronicAuthorization {
  relatedCoursePayment?: {
    originalPrice: number,
    title: string,
    used_cash: number,
    coupon_discount: number,
  }
  relation: {
    contents: string
    docNo: number
    idx: number
    isMain: boolean
    title: string
    /**
     * 업무 연기 타입인 경우에 존재함
     */
    additional_time?: number
    /**
     * 이하 환불 타입인 경우에만
     */
    site: string //dbDomain
    is_auto_refund?: boolean
    id?: string
    amount_deducted?: number
    amount_deducted_money?: number
    amount_deducted_report?: string
    amount_deducted_starCash?: number
    cashReceipt_state?: string
    displayPrice?: number
    /**
     * 일반 타입인 경우에만 존재
     */
    generalEaType?: GeneralEaType
    name?: string
    payPrice?: number
    paymentType?: string
    paymentNo: number
    payment_table: string
    pgCancelYn?: boolean
    refundPaymentType?: string
    refundPrice?: number
    refund_account_holder?: string
    refund_account_number?: string
    refund_bank?: string
    /**
     * 연차용
     */
    offType?: string
    offDays?: string
    /**
     * 연기신청용
     */
    schedule_list_no?: number
    autoRefundProcess?: string[]
  }
  signs: {
    admin_level: number
    docNo: number
    idx: number
    signature_time: string
    signature_type: "accept" | "reject"
    signer: string
    signerHan: string
  }[]
  /**
   * 환불 타입인 경우에만 가짐
   */
  payment?: ElectronicAuthorizationRefundPayment[]
  /**
   * 환불 상세 데이터
   */
  refundData?: ElectronicAuthorizationRefundData

  /**
   * 업무보고 타입인 경우에만 가짐
   */
  scheduleList?: WorkScheduleList[]
}

export interface ElectronicAuthorizationDelayList {

}

export interface DYAEaGetListParams {
  page: number,
  perPage: number,
  status?: string | 'request' | 'finish' | 'default' | 'writing'
  /**
   * 전자결재함 타입으로 요청할건지
   */
  eaType?: 'y'
  type?: string
  keyword?: string
  /**
   * 특정 환불 전자결재 건을 찾을 때 쓰임
   */
  'ear:payment_table'?: string
  /**
   * 특정 환불 전자결재 건을 찾을 때 쓰임
   */
  'ear:site'?: string
  /**
   * 특정 환불 전자결재 건을 찾을 때 쓰임
   */
  'ear:paymentNo'?: number
}

export type GeneralEaType = 'general' | 'wrongMoney' | 'workFromHomeApply' | 'workFromHome' | 'workSchedule' | 'workScheduleDelay'
export type EaType = 'refund' | 'holiday' | 'general' | 'workSchedule' | 'workScheduleDelay'
export type WorkType = '' | 'main' | 'open' | 'filming' | 'filmingSupport' | 'writing' | 'inspect' | 'edit' | 'fixed' | 'programming' | 'educate' | 'directedWork' | 'etc' | 'record' | 'movieOrganize' | 'inspectWriting'

export interface WorkScheduleList {
  idx: number
  start_day: string
  'is-main': boolean
  work_type: WorkType
  endTime?: string
  workAmount?: string
  /**
   * 자기 자신의 주키 - 메인업무를 일일에서 사용했을 때 주키
   */
  scheduled_list_no: number | null
  title: string
  ea: number
  /**
   * 마감까지 원하는 시간 분 단위
   */
  'about-time': number
  bigo: string
  is_canceled: boolean
  is_completed: boolean
  showBigo: boolean
  /**
   * 일일업무에서 스케쥴넘버가 있는 경우에만 존재할 것
   */
  main?: WorkScheduleList
}

export interface DYAEaStoreParams {
  title: string
  type: EaType
  content?: string
  /**
   * 업무보고 스케쥴
   */
  workScheduleList?: WorkScheduleList[]
}

export interface DYAEaScheduleListStoreParams {
  is_completed?: boolean
  is_canceled?: boolean
}

export interface DYAEaRefundFormParams {
  paymentNo: number
  payment_table: string
  type: 'refund'
  title: string
  require_auth_type: string[],
  contents: string
  id: string
  name: string
  payPrice: number
  amount_deducted: number
  amount_deducted_money: number
  amount_deducted_starCash: number
  displayPrice?: number
  amount_deducted_report: string
  refundPrice: number
  paymentType: string
  refundPaymentType: string
  refund_bank?: string
  refund_account_holder?: string
  refund_account_number?: string
  autoRefundProcess?: string[]
}

export function useElectronicAuthorizationManager() {
  const { CASH_NAME } = useDYAdminConfig()

  /**
   * 전자결재에서 쓰이는 결제 타입들. Payment 객체에서 사용하는 타입과 동일하지 않기 때문에 주의필요.
   */
  const refundPaymentTypeOptions = [
    { value: 'card', title: '신용카드' },
    { value: 'pcs', title: '핸드폰' },
    { value: 'account_transfer', title: '실시간계좌이체' },
    { value: 'withoutBankbook', title: '무통장입금' },
    { value: 'paypal', title: '페이팔결제' },
    { value: 'google_inapp', title: '구글 인앱결제' },
    { value: 'apple_inapp', title: '애플 인앱결제' },
    { value: 'lifelongEducation', title: '평생교육이용권' },
    { value: 'cultureCard', title: '문화누리카드' },
    { value: 'starCash', title: '별캐시' },
    { value: 'kakaoPay', title: '카카오페이' },
    { value: 'keyIn', title: '키인결제' },
    { value: 'thirdParty', title: '타사결제' },
    { value: 'brandPay', title: '브랜드페이' },
    // { value: 'brandPay', title: '도약페이' }, //브랜드페이라고 들어와서 도약페이만 있으면 용어 표기가 노출이 안되는 경우들이 있음
    { value: 'naverPay', title: '네이버페이' },
    { value: 'starCash', title: '쿠폰&별캐시' },
  ]

  const autoRefundProcessOptions = [
    { value: 'ignoreRefundableCheck', title: `환불 불가여도 강제 환불` },
    { value: 'restoreCoupon', title: `사용한 쿠폰 되돌림` },
    { value: 'restoreStartCash', title: `사용한 ${CASH_NAME} 환불` },
    { value: 'cancelStartCash', title: `발급된 ${CASH_NAME} 회수` },
    { value: 'cancelPoint', title: `발급된 포인트 회수` },
    { value: 'cancelCoupon', title: `발급된 쿠폰 취소` },
    { value: 'cancelCashReceipt', title: `현금영수증 취소(부분/전액)` },
    { value: 'cancelPayment', title: `결제 취소` },
  ]

  const typeHangul = (type: string) => {
    switch (type) {
      case 'open': return '편집+오픈'
      case 'writing': return '스크립트'
      case 'inspectWriting': return '자료조사+스크립트'
      case 'inspect': return '투어조사'
      case 'edit': return '정규편집'
      case 'main': return '메인'
      case 'filming': return '촬영'
      case 'filmingSupport': return '촬영보조'
      case 'fixed': return '고정업무'
      case 'programming': return '개발'
      case 'educate': return '교육/검수/도움'
      case 'directedWork': return '별도지시'
      case 'etc': return '기타'
      case 'cs': return 'cs'
      case 'record': return '녹음'
      case 'image': return '이미지작업'
      case 'remain': return '유지/보수'
      case 'cleaning': return '청소'
      case 'bug': return '버그'
      case 'pds': return '강의자료'
      case 'book': return '교재/제본'
      case 'purchase': return '비품구매'
      case 'posting': return '포스팅(블로그,매거진)'
      case 'review': return '후기/댓글관리'
      case 'good': return '준비물 관련'
      case 'movieOrganize': return '영상정리'
      case 'movieLightChange': return '영상갈이(+가벼운수정)'
      case 'writingTour': return '투어 (1만자 기준)'
      case 'cityTour': return '시티투어/명소 (예상 최종스크립트/1만자)'
      case 'museumTour': return '박물관/미술관 (기본120+작품당40)'
    }
  }

  /**
   * 업무기준시간을 넘겨 소중대등의 업무량 단위를 리턴. 주로 폼에서 사용?
   * @param workType 
   * @param workString  대중소 등으로 선택된 거에 따라 나온 기준시간
   */
  const workAmountCal = (workAmount: string, workEa: number) => {
    switch (workAmount) {
      case 'tour': return (workEa * 480) + 600
      case 'tourModify': return (workEa * 480)
      // case 'halfDay': return (workEa * 420) + 840
      case 'mini': return (workEa * 240) + 360
      case 'regular': return (workEa * 90) + 840
      case 'editIngang': return (workEa * 90)
      case 'timePerRoute': return (workEa * 100)
      case 'movieOrganize': return (workEa * 50)
      case 'movieLightChange': return (workEa * 144)
      case 'writingTour': return (workEa * 420)
      case 'record': return (workEa * 7)
      case 'cityTour': return (workEa * 420)
      case 'museumTour': return (workEa * 40) + 120
      default: return 0
    }
  }

  /**
   * 소중대등의 업무기준을 넘겨 실제 업무기준시간을 리턴. 주로 뷰에서 사용?
   * @param workType 
   * @param workString 
   * @returns 
   */
  const workAmountString = (workAmount: string) => {
    switch (workAmount) {
      case 'tour': return '투어((편집 7*n만자)+(신규오픈 10+1*n만자))'
      case 'tourModify': return '투어((편집 7*n만자)+(교체 1*n만자))'
      case 'mini': return '곡별/작품별 (60분 기준, 4+6)'
      case 'regular': return '정규강의 (1.5+14)'
      case 'editIngang': return '인강'
      case 'timePerRoute': return '기본 (1루트당 100분)'
      case 'movieOrganize': return '영상정리 (1만자기준)'
      case 'movieLightChange': return '영상갈이(+가벼운수정) (1만자기준)'
      case 'writingTour': return '투어 (1만자 기준)'
      case 'record': return '기본 (1,000자 기준)'
      case 'cityTour': return '시티투어/명소 (예상 최종스크립트/1만자)'
      case 'museumTour': return '박물관/미술관 (기본120+작품당40)'
    }

    return undefined
  }

  const eaTerm = (workAmount?: string) => {
    switch (workAmount) {
      case 'museumTour': return '작품 개수'
      case 'movieOrganize':
      case 'movieLightChange':
      case 'writingTour':
      case 'cityTour':
      case 'tourModify':
      case 'tour':
        return '만자당'
      case 'record':
        return '천자당'
      default: return '개수'
    }
  }

  const eaTermAfterEa = (workAmount?: string) => {
    switch (workAmount) {
      case 'museumTour': return '개'
      case 'movieOrganize':
      case 'movieLightChange':
      case 'writingTour':
      case 'cityTour':
        return '만자'
      case 'record':
        return '천자'
      default: return '개'
    }
  }

  return {
    refundPaymentTypeOptions,
    autoRefundProcessOptions,
    eaTerm,
    eaTermAfterEa,
    typeHangul,
    workAmountCal,
    workAmountString
  }
}

export function useElectronicAuthorizationApi() {
  const { API_BASE_URL } = useDYAppConfig()
  /**
   * 서명 승인 요청
   * @param sign 
   * @returns 
   */
  const checkSign = async (sign: string) => {
    return await $dy__fetchWithToken<{ resut: 'success' | 'error', message: string }>(`${API_BASE_URL}/api/ea-signs/check-sign`, { method: 'post', body: { sign } })
  }

  const submitSign = async (params: { docNo: number, signature_type: string, rejectComment?: string, endCommute?: boolean }) => {
    return await $dy__fetchWithToken<{ resut: 'success' | 'error', message: string }>(`${API_BASE_URL}/api/ea-signs`, { method: 'post', body: params })
  }

  const storeDelay = async (params: { schedule_list_no: number, additional_time: number, title: string, reason: string }) => {
    return await $dy__fetchWithToken<{ resut: 'success' | 'error', message: string }>(`${API_BASE_URL}/api/ea-work-delay-lists`, { method: 'post', body: params })
  }

  const getList = async (params: DYAEaGetListParams): Promise<ApiListStructure<ElectronicAuthorization>> => {
    const response = await useDYFetchWithToken<ApiListStructure<ElectronicAuthorization>>(`${API_BASE_URL}/api/eas`, { params, immediate: false })
    await response.execute({ dedupe: 'defer' })
    return extractDataOrFailure(response)
  }

  const get = async (pk: number) => {
    const response = await useDYFetchWithToken<ElectronicAuthorizationShow>(`${API_BASE_URL}/api/eas/${pk}`, { method: 'get', immediate: false })
    await response.execute({ dedupe: 'defer' })
    return extractDataOrFailure(response)
  }

  const getScheduleList = async (pk: number) => {
    const response = await useDYFetchWithToken<WorkScheduleList>(`${API_BASE_URL}/api/ea-work-schedule-lists/${pk}`, { method: 'get', immediate: false })
    await response.execute({ dedupe: 'defer' })
    return extractDataOrFailure(response)
  }

  const store = async (params: DYAEaStoreParams): Promise<ElectronicAuthorization> => {
    return await $dy__fetchWithToken<ElectronicAuthorization>(`${API_BASE_URL}/api/eas`, { method: 'post', body: params })
  }

  const destroy = async (pk: number) => {
    return await $dy__fetchWithToken<ApiSimpleResponseStructure>(`${API_BASE_URL}/api/eas/${pk}`, { method: 'delete' })
  }

  const update = async (pk: number, params: DYAEaStoreParams) => {
    return await $dy__fetchWithToken<ElectronicAuthorization>(`${API_BASE_URL}/api/eas/${pk}`, { method: 'patch', body: params })
  }

  const updateScheduleList = async (pk: number, params: DYAEaScheduleListStoreParams) => {
    return await $dy__fetchWithToken<ElectronicAuthorization>(`${API_BASE_URL}/api/ea-work-schedule-lists/${pk}`, { method: 'patch', body: params })
  }

  const getListScheduleList = async (params: any) => {
    const response = await useDYFetchWithToken<ApiListStructure<WorkScheduleList[]>>(`${API_BASE_URL}/api/ea-work-schedule-lists`, { method: 'get', params, immediate: false })
    await response.execute({ dedupe: 'defer' })
    return extractDataOrFailure(response)
  }

  return {
    getList,
    get,
    getScheduleList,
    store,
    update,
    updateScheduleList,
    destroy,
    getListScheduleList,
    checkSign,
    submitSign,
    storeDelay
  }
}